import React, {useState} from 'react';
import Select from 'react-select';
import NewReleasesIcon from '@mui/icons-material/NewReleases';
import { WifiPassword } from '@mui/icons-material';

const customStyles = {
  control: base => ({
    ...base,
    background: '#4b4b4b',
    borderRadius: '5px',
    fontSize: '14px',
    border: '1px solid #ffffff',
    marginBottom: '5px',
    marginTop: '10px',
    width: '250px'
  }),
  singleValue: base => ({
    ...base,
    color: '#ffffff', 
    
  }),
  input: base => ({
    ...base,
    color: '#ffffff', 
  }),
  menu: base => ({
    ...base,
    background: '#4b4b4b',
    color: '#ececec', 
    fontSize: '14px',
    width: '250px'
  }),
  option: (base, { isFocused }) => ({
    ...base,
    backgroundColor: isFocused ? '#bdbdbd' : 'transparent', 
    color: isFocused ? '#000000' : '#ececec', 
  }),
};

const WifiContainerEdit = ({toggleVisibilityWifi, isVisibleWifi, typeWifiData, handleChangeWifiType, selectedWifiType, commentWifi, commentTextWifi,
      handleCommentChangeWifi, toggleWifiMarker, wifiMarker, wifiPointSave, rankComponentData,
      dividerData, selectedDividerOptionFob, handleChangeDividerSelectFob, wifiModelData, selectedWifiModelId, handleChangeWifiModel, polishingData, selectedPolishing, handleChangePolishing,
      handleAreaWifiChange, areaWifi, handleIpWifiPointChange, ipWifiPoint, handleMacWifiPointChange, macWifiPoint, handleUplinkIpChange, uplinkIp, handleUplinkPortChange, uplinkPort,
      handleWifiLoginChange, wifiLogin, handleWifiPasswordChange, wifiPassword, handleControllerChange, controllerIp, handleStartDrawing,handleStopDrawing, plannedWifi, handlePlannedCheckboxChange }) => {

      const [showTooltip, setShowTooltip] = useState(false);
      const [showTooltipUplink, setShowTooltipUplink] = useState(false);

      const wifiTypeMap = {
        1: "PTP",
        2: "PTMP BASE",
        3: "CPE",
        4: "WIFI ZONE"
      };

      const groupedWifiModels = wifiModelData.reduce((acc, item) => {
        const groupName = wifiTypeMap[item.wifiModelTypeId] || "Другое";

        if (!acc[groupName]) {
          acc[groupName] = [];
        }

        acc[groupName].push(item);
        return acc;
      }, {});

  return (
    <React.Fragment>
      <button onClick={toggleVisibilityWifi} className={isVisibleWifi ? 'buttonIsHideDrawer2' : 'buttonIsHideDrawer'} >
        {isVisibleWifi ? 'Антенна: скрыть' : 'Антенна: показать'}
      </button>
      {isVisibleWifi && (
        <div className='divСommunicationsDrawer'>
        
      {selectedWifiType === '1' || selectedWifiType === '2' ? (
           <img src='./wifi_ap.png' width='30' height='30' style={{ marginRight: "5px" }} />
            ) : (
            <img src='./wifi_hotspot.png' width='30' height='30' style={{ marginRight: "5px" }} />
          )}  

          <label className='textTitleWifiDrawer'>Wi-Fi</label>
          <hr className="horizontalLineWifiDrawer" />
          <div style={{marginLeft: '-10px'}}> 

            



             <div className="divСommunicationsDrawer" style={{ border: '1px solid #d6b220'}}>

            <div style={{ display: 'flex', alignItems: 'center' }}>
              <input
                type="checkbox"
                 checked={plannedWifi === 1}
                 onChange={handlePlannedCheckboxChange}
                style={{ marginRight: '5px' }}
              />
              <label style={{ marginRight: '10px' , color: '#f0f0f0ff'}}>Проектная</label>
               <div
                style={{
                  position: "relative",
                  display: "inline-block",
                }}
                onMouseEnter={() => setShowTooltip(true)}
                onMouseLeave={() => setShowTooltip(false)}
              >
                <NewReleasesIcon
                  style={{
                    cursor: "pointer",
                    color: "#ebb434",
                    fontSize: "24px",
                    marginLeft: "5px",
                  }}
                />
                {showTooltip && (
                  <div className='tooltipWarning' style={{fontSize: '12px'}}>
                    Точка ещё не установлена,<br/> находится на этапе проекта
                  </div>
                )}
              </div>
            </div>
           
             <hr className="horizontalLineWifiDrawer" />

            <label className='textTitleWifiDrawer' style={{fontSize: '15px'}}>Модель: </label><br/>
           <select
              className="selectStyleDrawer"
              style={{ fontSize: '14px', marginBottom: "5px", marginTop: "10px" }}
              onChange={handleChangeWifiModel}
              value={selectedWifiModelId}
            >
              <option value="">выберите модель</option>

              {Object.entries(groupedWifiModels).map(([groupName, models]) => (
                <optgroup key={groupName} label={groupName}>
                  {models.map(model => (
                    <option key={model.id} value={model.id}>
                      {model.model}
                    </option>
                  ))}
                </optgroup>
              ))}
            </select>

            <br/>
              <label className='textTitleWifiDrawer' style={{fontSize: '15px', marginRight: '5px'}}>Тип: </label>
           <select className="selectStyleDrawer" style={{ marginBottom: "5px", marginTop: "10px", fontSize: '14px' }} onChange={handleChangeWifiType} value={selectedWifiType}>
              <option value="null">выберите тип</option>
              {typeWifiData.map(type => (
                <option key={type.id} value={type.id}>{type.type}</option>
              ))}
            </select>
            <br/>
</div>



  <div className="divСommunicationsDrawer" style={{ border: '1px solid #d6b220'}}>
             <label className='textTitleWifiDrawer' style={{fontSize: '15px', marginRight: '5px'}} >Ветка: </label>
                        
                    <input
                      type='number'
                      min={0}
                      placeholder='№'
                      className='textInput2EditingModal'
                      value={areaWifi} 
                      style={{fontSize: '14px', marginRight: '5px'}}
                      onChange={handleAreaWifiChange} 
                    />  
                    </div>



  <div className="divСommunicationsDrawer" style={{ border: '1px solid #d6b220'}}>
 <label className='textTitleWifiDrawer' style={{fontSize: '15px', marginRight: '5px'}}>Ip: </label>
                        
                    <input
                      type='text'
                      min={0}
                      className='textInput2EditingModal'
                      placeholder='ip'
                      value={ipWifiPoint}
                      style={{fontSize: '14px', marginRight: '5px', width: '130px'}} 
                      onChange={handleIpWifiPointChange} 
                    />  
                    <br/>
                     <label className='textTitleWifiDrawer' style={{fontSize: '15px', marginRight: '5px'}}>Mac: </label>
                      
                    <input
                      type='text'
                      min={0}
                      placeholder='mac'
                      style={{fontSize: '14px', marginRight: '5px', width: '130px'}}
                      className='textInput2EditingModal'
                      value={macWifiPoint} 
                      onChange={handleMacWifiPointChange} 
                    />  
 <hr className="horizontalLineWifiDrawer" />
     <label className='textTitleWifiDrawer' style={{fontSize: '15px', marginRight: '5px'}}>Uplink: </label>
                        
                    <input
                      type='text'
                      min={0}
                      placeholder='ip'
                      className='textInput2EditingModal'
                      value={uplinkIp} 
                      style={{fontSize: '14px', marginRight: '5px', width: '130px'}}
                      onChange={handleUplinkIpChange} 
                    />  
                     <input
                      type='number'
                      min={0}
                      className='textInput2EditingModal'
                      value={uplinkPort} 
                      placeholder='port'
                      style={{fontSize: '14px', marginRight: '5px', width: '70px'}}
                      onChange={handleUplinkPortChange} 
                    /> 

                     <div
                        style={{
                          position: "relative",
                          display: "inline-block",
                        }}
                        onMouseEnter={() => setShowTooltipUplink(true)}
                        onMouseLeave={() => setShowTooltipUplink(false)}
                      >
                        <NewReleasesIcon
                          style={{
                            cursor: "pointer",
                            color: "#ebb434",
                            fontSize: "24px",
                            marginLeft: "5px",
                          }}
                        />
                        {showTooltipUplink && (
                          <div className='tooltipWarning'style={{fontSize: '12px'}} >
                            - BaseStation (switch / port)<br/>
                            - Station (BaseStation / port)<br/>
                            - Access Point (switch / port)<br/>
                          </div>
                        )}
                     </div>
                    
                      <hr className="horizontalLineWifiDrawer" />


                        <label className='textTitleWifiDrawer' style={{fontSize: '15px', marginRight: '5px'}}>Контроллер: </label>
                      
                    <input
                      type='text'
                      min={0}
                      placeholder='ip'
                      style={{fontSize: '14px', marginRight: '5px', width: '130px'}}
                      className='textInput2EditingModal'
                      value={controllerIp} 
                      onChange={handleControllerChange} 
                    />  

  </div>

   <div className="divСommunicationsDrawer" style={{ border: '1px solid #d6b220'}}>
                     <label className='textTitleWifiDrawer' style={{fontSize: '15px'}}>Логин: </label>
                        
                    <input
                      type='text'
                      min={0}
                      placeholder='login'
                      className='textInput2EditingModal'
                      value={wifiLogin} 
                      style={{fontSize: '14px', marginRight: '5px', width: '200px'}}
                      onChange={handleWifiLoginChange} 
                    />  
 <br/>
                      <label className='textTitleWifiDrawer' style={{fontSize: '15px'}}>Пароль: </label>
                        
                    <input
                      type='text'
                      min={0}
                      placeholder='password'
                      className='textInput2EditingModal'
                      value={wifiPassword} 
                       style={{fontSize: '14px', marginRight: '5px', width: '200px'}}
                      onChange={handleWifiPasswordChange} 
                    />  
</div>
                   
                     





            
          

            
          </div>
          <div >

            <textarea
              className='areaDescriptionDrawer'
              placeholder="Комментарий"
              rows={3}
              cols={44}
              value={commentWifi}
              ref={commentTextWifi}
              onChange={handleCommentChangeWifi}
            />
            <button onClick={toggleWifiMarker} className={wifiMarker ? 'buttonIsDrawingDrawer2' : 'buttonIsDrawingDrawer'}>
              {wifiMarker ? 'Завершить' : 'Добавить'}
            </button>
            <button onClick={wifiPointSave} className='buttonSaveDrawer'>Сохранить</button>
          </div>
        </div>
      )}
    </React.Fragment>
  );
}

export default WifiContainerEdit;